{
	"title": "{{productName}} transactiegeschiedenis",
	"item": {
		"time": "Tijd",
		"description": "Beschrijving",
		"transactionId": "Transactie-ID",
		"showIds": "ID's tonen",
		"depositTitle": "Assurance door DNV, waardoor een storting in de carbon bank mogelijk is",
		"depositDescription": "Zodra de externe assurance-instelling 'DNV' het opgeslagen volume afgevangen CO\u2082 heeft geborgd in een digitaal Monitor-Report-Verify-systeem, wordt een nieuwe storting in de carbon bank gedaan.",
		"withdrawalTitle": "Factuur aan leverancier, waardoor een opname uit de carbon bank wordt geactiveerd",
		"withdrawalDescription": "Bij het factureren van evoZero-materiaal aan de leverancier is een opname uit de carbon bank uitgevoerd.",
		"transferTitle": "Overdracht van CO\u2082-reducties aan verklaringhouder",
		"transferDescription": "De leverancier heeft, op basis van het volume evoZero-materiaal dat in het geleverde product is verwerkt, de overdracht van de CO\u2082-reducties aan de verklaringhouder geïnitieerd."
	},
	"proofIdsModal": {
		"titleTransactions": "Transacties bekijken",
		"titleMeasurements": "Metingen bekijken",
		"paragraph1": "Eén transactiestap op {{productName}} omvat het aggregeren van transacties op het gedistribueerde grootboek. Hieronder vindt u een lijst met links naar externe diensten waar u deze transacties kunt bekijken.",
		"paragraph2": "Let op: deze links leiden naar externe websites die transacties kunnen weergeven.",
		"open": "Openen",
		"close": "Sluiten"
	},
	"errors": {
		"fetch": "Activiteitengeschiedenis kon niet worden opgehaald"
	}
}
